import { render } from "./Record.vue?vue&type=template&id=2ce326a8&scoped=true"
import script from "./Record.vue?vue&type=script&lang=js"
export * from "./Record.vue?vue&type=script&lang=js"

import "./Record.vue?vue&type=style&index=0&id=2ce326a8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2ce326a8"

export default script